import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalf } from "@fortawesome/free-solid-svg-icons";

const Rating = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const starElements = [];

  for (let i = 0; i < fullStars; i++) {
    starElements.push(
      <FontAwesomeIcon icon={faStar} key={i} color="#ffc107" className="text-[22px]" />
    );
  }

  if (hasHalfStar) {
    starElements.push(
      <FontAwesomeIcon icon={faStarHalf} key="half" color="#ffc107" className="text-[22px]" />
    );
  }

  const remainingStars = 5 - starElements.length;
  for (let i = 0; i < remainingStars; i++) {
    starElements.push(
      <FontAwesomeIcon icon={faStar} key={`empty-${i}`} color="#e4e5e9" className="text-[22px]" />
    );
  }

  return <div className="flex items-center gap-[4px]">{starElements}</div>;
};

Rating.propTypes = {
  rating: PropTypes.number.isRequired,
};

export default Rating;

// import React from "react";

// const Rating = ({ rating }) => {
//   const fullStars = Math.floor(rating);
//   const hasHalfStar = rating % 1 !== 0;
//   const maxStars = 5;

//   const starElements = Array.from({ length: maxStars }, (_, i) => {
//     if (i < fullStars) return <span key={i} className="text-[22px] text-[#ffc107]">★</span>;
//     if (i === fullStars && hasHalfStar) return <span key="half" className="text-[22px] text-[#ffc107]">⯪</span>;
//     return <span key={`empty-${i}`} className="text-[22px] text-[#e4e5e9]">☆</span>;
//   });

//   return <div className="flex items-center gap-[4px]">{starElements}</div>;
// };


// export default Rating;

